export default function debounce(func, wait, immediate) {
  let timeout;

  return function executedFunction() {
    const args = arguments;

    const later = function later() {
      timeout = null;
      if (!immediate) func.apply(this, args);
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(this, args);
  };
}
